import {
  getProfile,
  postCommunications,
  getCommunications
} from "@/apis/auth/index";
export const commonModule = {
  namespaced: true,
  state: () => ({
    firstName: "",
    lastName: "",
    email: "",
    avatar: ""
  }),
  mutations: {
    getProfile(state, payload) {
      state.firstName = payload.firstName;
      state.lastName = payload.lastName;
      state.email = payload.email;
    }
  },
  actions: {
    getProfile({ commit }) {
      return getProfile().then(res => {
        commit("getProfile", res.data);
        return res.data;
      });
    },

    postCommunication() {
      return postCommunications().then(res => {
        return res;
      });
    },
    getCommunications() {
      return getCommunications().then(res => {
        return res;
      });
    }
  }
};
